import { persistor, store } from "@/redux/store";
import { AppRoutes } from "@/routes";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import "./App.css";
import { PostHogIdentifier } from "./components/PostHogIdentifier";
import { SentryUserIdentifier } from "./sentry/SentryUserIdentifier";
import { Toaster } from "./components/ui/sonner";
import ErrorBoundary from "./sentry/ErrorBoundary";
import { FeatureFlagsProvider } from "./context/FeatureFlagsContext";
import { pdfjs } from "react-pdf";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "@/lib/query-client";

import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <PostHogIdentifier />
          <SentryUserIdentifier />
          <FeatureFlagsProvider>
            <ErrorBoundary>
              <AppRoutes />
              <Toaster richColors position="bottom-right" />
            </ErrorBoundary>
          </FeatureFlagsProvider>
        </PersistGate>
      </Provider>
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
}

export default App;
